import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDriverStore } from '../../store/driverStore';
import { MaterialCommunityIcons } from '../../utils/icons';
import { Colors } from '../../theme/colors';
import './EarningsScreen.css';

const EarningsScreen: React.FC = () => {
  const navigate = useNavigate();
  const { earnings, stats, getEarnings, getStats } = useDriverStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    await Promise.all([getEarnings(), getStats()]);
    setLoading(false);
  };

  if (loading) {
    return <div className="earnings-loading"><div className="loading-spinner"></div></div>;
  }

  return (
    <div className="earnings-container">
      <div className="earnings-header">
        <button onClick={() => navigate('/')}><MaterialCommunityIcons name="arrow-back" size={24} /></button>
        <h1>Earnings</h1>
      </div>
      <div className="earnings-content">
        <div className="balance-card">
          <p>Total Earnings</p>
          <h2>${earnings?.total_earnings?.toFixed(2) || '0.00'}</h2>
          <span>All Time</span>
        </div>
        <div className="stats-grid">
          <div className="stat-card">
            <MaterialCommunityIcons name="directions-car" size={28} color={Colors.primary} />
            <p className="stat-value">{stats?.total_rides || 0}</p>
            <p className="stat-label">Total Rides</p>
          </div>
          <div className="stat-card">
            <MaterialCommunityIcons name="star" size={28} color={Colors.warning} />
            <p className="stat-value">{stats?.average_rating?.toFixed(1) || '0.0'}</p>
            <p className="stat-label">Avg Rating</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EarningsScreen;







